module.exports = __webpack_public_path__ + "static/media/laptop_backpack.96739588.jpg";